import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
export function PrivacyPage() {
  return <LegalLayout title="Política de Privacidade" lastUpdated="04 de maio de 2026" data-id="element-711">
      <Section data-id="element-712">
        <p data-id="element-713">
          A Aurora ("a Aurora", "nós", "nossa") respeita a sua privacidade e
          está comprometida com a proteção dos seus dados pessoais, em
          conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº
          13.709/2018 - LGPD).
        </p>
      </Section>

      <Section title="1. Controladora dos dados" data-id="element-714">
        <p data-id="element-715">
          Sediada em São Paulo, SP, a Aurora é a controladora dos dados pessoais
          coletados.
        </p>
        <p data-id="element-716">
          Contato para questões de privacidade:{' '}
          <a href="mailto:suporte@myaurora.com.br" data-id="element-717">suporte@myaurora.com.br</a>
        </p>
      </Section>

      <Section title="2. Dados que coletamos" data-id="element-718">
        <p data-id="element-719">
          <strong data-id="element-720">2.1. Dados de cadastro:</strong>
        </p>
        <ul data-id="element-721">
          <li data-id="element-722">Nome completo</li>
          <li data-id="element-723">Email</li>
          <li data-id="element-724">Senha (armazenada de forma criptografada — não temos acesso)</li>
        </ul>
        <p data-id="element-725">
          <strong data-id="element-726">2.2. Dados de pagamento:</strong>
        </p>
        <ul data-id="element-727">
          <li data-id="element-728">Não coletamos nem armazenamos dados de cartão de crédito</li>
          <li data-id="element-729">
            Pagamentos são processados pela Hotmart, sujeitos à política dela
          </li>
        </ul>
        <p data-id="element-730">
          <strong data-id="element-731">2.3. Dados de uso da plataforma:</strong>
        </p>
        <ul data-id="element-732">
          <li data-id="element-733">
            Matérias-primas, produtos, pacotes e pedidos cadastrados por você
          </li>
          <li data-id="element-734">Configurações de margem, alertas e preferências</li>
          <li data-id="element-735">Histórico de preços e alterações</li>
        </ul>
        <p data-id="element-736">
          <strong data-id="element-737">2.4. Dados técnicos:</strong>
        </p>
        <ul data-id="element-738">
          <li data-id="element-739">Endereço IP</li>
          <li data-id="element-740">Tipo e versão de navegador</li>
          <li data-id="element-741">Sistema operacional</li>
          <li data-id="element-742">Datas e horários de acesso</li>
          <li data-id="element-743">Páginas visitadas dentro da plataforma</li>
        </ul>
      </Section>

      <Section title="3. Como usamos seus dados" data-id="element-744">
        <p data-id="element-745">
          <strong data-id="element-746">3.1. Para fornecer o serviço:</strong>
        </p>
        <ul data-id="element-747">
          <li data-id="element-748">Autenticar seu acesso</li>
          <li data-id="element-749">Armazenar e processar seus dados de gestão</li>
          <li data-id="element-750">Realizar cálculos de precificação e relatórios</li>
        </ul>
        <p data-id="element-751">
          <strong data-id="element-752">3.2. Para comunicação:</strong>
        </p>
        <ul data-id="element-753">
          <li data-id="element-754">
            Enviar emails transacionais (confirmação de cadastro, recuperação de
            senha, boas-vindas após compra)
          </li>
          <li data-id="element-755">Notificar sobre alterações importantes do serviço</li>
          <li data-id="element-756">Responder a solicitações de suporte</li>
        </ul>
        <p data-id="element-757">
          <strong data-id="element-758">3.3. Para melhoria do serviço:</strong>
        </p>
        <ul data-id="element-759">
          <li data-id="element-760">Analisar padrões de uso (de forma agregada e anônima)</li>
          <li data-id="element-761">Identificar e corrigir problemas técnicos</li>
          <li data-id="element-762">Desenvolver novas funcionalidades</li>
        </ul>
        <p data-id="element-763">
          <strong data-id="element-764">3.4. Para cumprimento legal:</strong>
        </p>
        <ul data-id="element-765">
          <li data-id="element-766">Atender obrigações fiscais, tributárias e regulatórias</li>
          <li data-id="element-767">Responder a ordens judiciais ou autoridades competentes</li>
        </ul>
      </Section>

      <Section title="4. Base legal" data-id="element-768">
        <p data-id="element-769">Tratamos seus dados com base em:</p>
        <ul data-id="element-770">
          <li data-id="element-771">Execução de contrato (assinatura da Aurora)</li>
          <li data-id="element-772">Cumprimento de obrigação legal</li>
          <li data-id="element-773">Legítimo interesse para melhoria do serviço</li>
          <li data-id="element-774">Consentimento (quando aplicável)</li>
        </ul>
      </Section>

      <Section title="5. Compartilhamento de dados" data-id="element-775">
        <p data-id="element-776">
          5.1. Não vendemos, alugamos ou comercializamos seus dados pessoais.
        </p>
        <p data-id="element-777">
          5.2. Compartilhamos dados apenas com os seguintes parceiros
          essenciais:
        </p>
        <ul data-id="element-778">
          <li data-id="element-779">Supabase (banco de dados e autenticação)</li>
          <li data-id="element-780">Vercel (hospedagem do aplicativo)</li>
          <li data-id="element-781">Hotmart (processamento de pagamentos)</li>
          <li data-id="element-782">Resend (envio de emails transacionais)</li>
        </ul>
        <p data-id="element-783">
          5.3. Todos os parceiros estão sujeitos a contratos de
          confidencialidade e proteção de dados.
        </p>
        <p data-id="element-784">
          5.4. Podemos divulgar dados quando exigido por lei, ordem judicial ou
          para proteger nossos direitos.
        </p>
      </Section>

      <Section title="6. Armazenamento e segurança" data-id="element-785">
        <p data-id="element-786">
          6.1. Seus dados são armazenados em servidores localizados no Brasil
          (região São Paulo).
        </p>
        <p data-id="element-787">6.2. Utilizamos medidas técnicas de segurança incluindo:</p>
        <ul data-id="element-788">
          <li data-id="element-789">Criptografia de senhas</li>
          <li data-id="element-790">Conexões HTTPS em todas as comunicações</li>
          <li data-id="element-791">
            Row Level Security (RLS) — cada usuária acessa apenas os próprios
            dados
          </li>
          <li data-id="element-792">Tokens de autenticação JWT</li>
          <li data-id="element-793">Auditoria de eventos de pagamento</li>
        </ul>
        <p data-id="element-794">
          6.3. Apesar dos esforços, nenhum sistema é 100% seguro. Você concorda
          que utiliza a Aurora por sua conta e risco.
        </p>
      </Section>

      <Section title="7. Retenção de dados" data-id="element-795">
        <p data-id="element-796">7.1. Mantemos seus dados enquanto sua conta estiver ativa.</p>
        <p data-id="element-797">
          7.2. Após o cancelamento, dados ficam preservados por até 30 dias para
          possível reativação.
        </p>
        <p data-id="element-798">
          7.3. Após esse período, dados são permanentemente excluídos, exceto:
        </p>
        <ul data-id="element-799">
          <li data-id="element-800">
            Dados financeiros que devemos manter por 5 anos (obrigação fiscal)
          </li>
          <li data-id="element-801">Logs de eventos de pagamento (Hotmart) por 5 anos</li>
          <li data-id="element-802">Outros dados exigidos por lei</li>
        </ul>
      </Section>

      <Section title="8. Seus direitos (LGPD)" data-id="element-803">
        <p data-id="element-804">Como titular dos dados, você tem direito a:</p>
        <p data-id="element-805">
          <strong data-id="element-806">8.1. Confirmação e acesso:</strong> saber quais dados temos
          sobre você.
        </p>
        <p data-id="element-807">
          <strong data-id="element-808">8.2. Correção:</strong> solicitar correção de dados
          incompletos ou desatualizados.
        </p>
        <p data-id="element-809">
          <strong data-id="element-810">8.3. Anonimização ou eliminação:</strong> solicitar exclusão
          dos dados quando aplicável.
        </p>
        <p data-id="element-811">
          <strong data-id="element-812">8.4. Portabilidade:</strong> exportar seus dados em formato
          estruturado (CSV).
        </p>
        <p data-id="element-813">
          <strong data-id="element-814">8.5. Revogação do consentimento:</strong> cancelar permissões
          dadas anteriormente.
        </p>
        <p data-id="element-815">
          <strong data-id="element-816">8.6. Informação sobre compartilhamento:</strong> saber com
          quem compartilhamos seus dados.
        </p>
        <p data-id="element-817">
          <strong data-id="element-818">8.7. Reclamação à ANPD:</strong> caso entenda que seus
          direitos não foram respeitados.
        </p>
        <p data-id="element-819">
          Para exercer seus direitos, envie email para{' '}
          <a href="mailto:suporte@myaurora.com.br" data-id="element-820">suporte@myaurora.com.br</a>.
          Responderemos em até 15 dias úteis.
        </p>
      </Section>

      <Section title="9. Exclusão de conta" data-id="element-821">
        <p data-id="element-822">
          9.1. Você pode excluir sua conta a qualquer momento via Configurações
          da Aurora.
        </p>
        <p data-id="element-823">9.2. A exclusão remove permanentemente:</p>
        <ul data-id="element-824">
          <li data-id="element-825">Sua conta de acesso</li>
          <li data-id="element-826">Todas as matérias-primas, produtos, pacotes e pedidos</li>
          <li data-id="element-827">Configurações pessoais</li>
          <li data-id="element-828">Histórico de preços</li>
          <li data-id="element-829">Avatar e foto de perfil</li>
          <li data-id="element-830">Dados de assinatura</li>
        </ul>
        <p data-id="element-831">
          9.3. Após a exclusão, não há possibilidade de recuperação dos dados.
        </p>
      </Section>

      <Section title="10. Cookies e tecnologias similares" data-id="element-832">
        <p data-id="element-833">
          10.1. Utilizamos cookies essenciais para autenticação e funcionamento
          da Aurora.
        </p>
        <p data-id="element-834">
          10.2. Não utilizamos cookies de rastreamento publicitário dentro da
          plataforma.
        </p>
        <p data-id="element-835">
          10.3. Você pode desativar cookies no seu navegador, mas isso pode
          comprometer o funcionamento da Aurora.
        </p>
      </Section>

      <Section title="11. Crianças e adolescentes" data-id="element-836">
        <p data-id="element-837">11.1. A Aurora não é destinada a menores de 18 anos.</p>
        <p data-id="element-838">11.2. Não coletamos intencionalmente dados de menores.</p>
        <p data-id="element-839">
          11.3. Caso identifiquemos dados de menores, serão excluídos
          imediatamente.
        </p>
      </Section>

      <Section title="12. Alterações nesta Política" data-id="element-840">
        <p data-id="element-841">12.1. Podemos atualizar esta Política periodicamente.</p>
        <p data-id="element-842">
          12.2. Mudanças significativas serão comunicadas por email com pelo
          menos 15 dias de antecedência.
        </p>
        <p data-id="element-843">12.3. Recomendamos revisar esta página regularmente.</p>
      </Section>

      <Section title="13. Contato" data-id="element-844">
        <p data-id="element-845">Para questões sobre privacidade, dados pessoais ou esta Política:</p>
        <ul data-id="element-846">
          <li data-id="element-847">
            Email:{' '}
            <a href="mailto:suporte@myaurora.com.br" data-id="element-848">suporte@myaurora.com.br</a>
          </li>
          <li data-id="element-849">
            Site:{' '}
            <a href="https://myaurora.com.br" target="_blank" rel="noreferrer" data-id="element-850">
              myaurora.com.br
            </a>
          </li>
        </ul>
        <p data-id="element-851">
          Você também pode contatar a Autoridade Nacional de Proteção de Dados
          (ANPD) em{' '}
          <a href="https://www.gov.br/anpd" target="_blank" rel="noreferrer" data-id="element-852">
            www.gov.br/anpd
          </a>
          .
        </p>
      </Section>
    </LegalLayout>;
}
function Section({
  title,
  children
}: {
  title?: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-853">
      {title && <h2 className="font-serif font-bold text-xl md:text-2xl text-ink mb-4 mt-2" data-id="element-854">
          {title}
        </h2>}
      <div className="space-y-3 text-[15px] md:text-[16px] leading-[1.7] text-ink-soft" data-id="element-855">
        {children}
      </div>
    </section>;
}